import BroadcastData from "./BroadcastData";
export default BroadcastData;